export default "__VITE_ASSET__z9MNV1BL__"